import cx from 'classnames';

import Text from 'shared_components/Text';

import trippyOGI from 'assets/cards/trippyOGI.png';
// import bryanbrinkman from 'assets/cards/brinkman.png';
import AlottaMoney from 'assets/cards/AlottaMoney.png';
import TheBakaArts from 'assets/cards/TheBakaArts.png';
import bitcoinlouie from 'assets/cards/bitcoinlouie.png';
import bananakin from 'assets/cards/bananakin.png';
import styles from '../../styles.module.scss';

const UltimatePhysicalNFT = (props: React.HTMLProps<HTMLDivElement>) => (
  <div {...props} className={cx(styles.ultimatePhysicalNFT, props.className)}>
    <div className={styles.infoBlock}>
      <div className={styles.left}>
        <div className={styles.cardStack}>
          <div className={styles.itemFive}>
            <img
              src={AlottaMoney}
              alt="Alotta Money"
              className={styles.sampleCard}
            />
          </div>
          <div className={styles.itemFour}>
            <img
              src={'https://cdn2.kolectiv.gg/card/render/34/118/402x670/845e55fa-4b75-4362-ac46-379cd2a493cb.png'}
              alt="To The Moon by Timpers"
              className={styles.sampleCard}
            />
          </div>
          <div className={styles.itemThree}>
            <img
              src={'https://cdn2.kolectiv.gg/card/render/137/320/402x670/755398e1-214b-41b4-aae5-404771219f5d.png'}
              alt="The Seed by Foreverlands"
              className={styles.sampleCard}
            />
          </div>
          <div className={styles.itemTwo}>
            <img
              src={'https://cdn2.kolectiv.gg/card/render/100/208/402x670/11976352-cfee-43a4-9d56-b4f9ce6f9660.png'}
              alt="Pump King by XCOPY"
              className={styles.sampleCard}
            />
          </div>
          <div className={styles.itemOne}>
            <img
              src={'https://cdn2.kolectiv.gg/card/render/37/169/402x670/9f7b99bd-822e-40ae-8faf-2abcdda20539.png'}
              alt="Bull Market by Concept Art House"
              className={styles.sampleCard}
            />
          </div>
        </div>
        <Text
          capitalize
          as="h3"
          size="2xl"
          weight="medium"
          className={styles.gradientText}
        >
          Unique <strong>Digital NFT</strong> <strong>Trading Cards</strong>
        </Text>

        <Text as="p" size="md" weight="regular">
          Multiple sets of unique trading cards featuring artwork from top NFT
          artists and projects. Open packs and try to complete the sets to get special rewards.
        </Text>
      </div>
    </div>

    {/* <Button
      rounded="full"
      className={styles.gradientBtn}
      onClick={scrollNextLandingSection}
    >
      Learn more
    </Button> */}
  </div>
);

export default UltimatePhysicalNFT;
